import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './index.css'
import './interceptors/axios'



// import the package
import VueAwesomePaginate from "vue-awesome-paginate";

// import the necessary css file
import "vue-awesome-paginate/dist/style.css";



// import  ModelSelect from 'vue-search-select'
// import 'vue-search-select/dist/VueSearchSelect.css'


const app =  createApp(App)
app.use(store)
app.use(router)
app.use(VueAwesomePaginate)
app.mount('#app')
